import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const GraphWrapper = styled.div<{ paddingBottom?: number; ix?: number }>`
  position: absolute;
  bottom: ${(props) => (props.paddingBottom ? props.paddingBottom : 0)}px;
  left: 0px;
  right: 0px;
  z-index: ${(props) => (props.ix ? props.ix : '0')};
  overflow: hidden;
`;

export const GradiantOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0px;
  right: 0px;
  z-index: 1;
  overflow: hidden;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 5%, rgba(185, 212, 215, 0) 80%);
`;
export const BottomFiller = styled.div<{ off?: boolean }>`
  background: ${(props) => (props.off ? 'rgba(185, 212, 215, 0)' : 'rgba(185, 212, 215, 1)')};
  height: 30px;
  width: 100%;
  margin-top: -2px;

  ${mq(Devices.laptop)} {
    height: 15px;
  }

  ${mq(Devices.mobile)} {
    height: 20px;
  }
`;
